import PDFObject from "pdfobject";
import React, { useEffect, useState } from "react";

const PDFViewer = ({
  width = "100%",
  height = "600px",
  data,
  containerID = "pdf-viewer",
  title = "",
}) => {
  const [heightIfFailed, setHeightIfFailed] = useState(height);

  useEffect(() => {
    if (!data) {
      return undefined;
    }

    const container = document.getElementById(containerID);
    if (container) {
      container.innerHTML = "";
    }

    const binaryString = window.atob(data.split(",")[1]);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i += 1) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const pdfBlob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(pdfBlob);

    const options = {
      title,
      forcePDFJS: true,
      fallbackLink: `
        <div style="text-align: center; padding: 20px;">
          <p style="margin-bottom: 15px;">Your browser doesn't support PDF preview.</p>
          <a href="${url}" 
             download="${title || "document"}.pdf" 
             style="display: inline-block; 
                    padding: 10px 20px; 
                    background-color: #007bff; 
                    color: white; 
                    text-decoration: none; 
                    border-radius: 4px;">
            Download PDF
          </a>
        </div>
      `,
    };

    const embeddedPDF = PDFObject.embed(url, `#${containerID}`, options);
    setHeightIfFailed(embeddedPDF === false ? "" : height);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [data, containerID, height, title]);

  return <div id={containerID} style={{ width, height: heightIfFailed }} />;
};

export default PDFViewer;
